import { Button } from "@mui/material"
import palette from "../../utilities/palette"


export const CommonButton = ({ children, onClick = () => {}, disabled, variant, sx={} }: {
  children: React.ReactNode,
  onClick?: (e) => any,
  disabled?: boolean,
  variant?: "text" | "outlined" | "contained",
  sx?: React.CSSProperties
}) => {

    return (
  <Button 
    onClick={onClick} 
    variant="contained" 
    disabled={disabled}
    sx={
      {
        backgroundColor: palette.main,
        color: palette.secondary,
        fontFamily: 'FordF-1-Regular',
        '&:hover': {
          backgroundColor: palette.hover
        },
        '&:disabled': {
          backgroundColor: palette.disabled.background,
          color: palette.disabled.text,
        },
        ...sx,
      }}>{children}</Button>)}